export const updateUrl = () => {
  window.history.replaceState({ orderPage: true }, '', document.location.href);
};

/** @param {string} url */
const changeUrl = (url) => {
  if (window.location.href !== url) {
    window.history.pushState({ orderPage: true }, '', url);
  }
};

/** @param {string} element */
export function setOrderHash() {
  const url = window.location.href;
  const store = window.localStorage.getItem('OrderFormStore');
  updateUrl();

  if (url.includes('cart')) {
    changeUrl('/cart/order');
  } else {
    changeUrl('/cart');
  }

  if (store) {
    window.location.hash = `#step-${JSON.parse(store).states.step}`;
  } else {
    window.location.hash = '#step-1';
  }
}

/** @param {HTMLElement} element */
export function setOpenedClassToChildrenElements(element) {
  if (element !== null) {
    let lastActive = element.querySelector('.active');

    [...element.children].forEach((tab) => {
      tab.addEventListener('click', () => {
        if (lastActive !== null) {
          lastActive.classList.remove('active');
        }

        tab.classList.toggle('active');
        lastActive = tab;
      });
    });
  }
}

/** @param jQueryElement */
export function jOnOrderActiveTabs(element) {
  element.on('show.bs.collapse', (tab) => {
    element.find('.active').removeClass('active');
    $(tab.target).parent().addClass('active');
    window.location.hash = `${tab.target.id}`;
  });
}

/** @param jQueryElement */
export function jOnHashAccordion(element) {
  const { hash } = window.location;
  if (hash) {
    element.find(hash).collapse('show');
  }

  $(window).on('hashchange', () => {
    element.find(window.location.hash).collapse('show');
  });
}

const oldBtnsHTML = [];
/**
 * @param { boolean } state
 */
export function orderUpdateState(state) {
  const sendBtns = document.querySelectorAll('#getOrder, [data-card-remove]');

  if (sendBtns !== null) {
    [...sendBtns].forEach((btn, index) => {
      const reloadHTML = '<span class="spinner-border spinner-border-sm text-primary mr-2" role="status"></span> Пересчет...';

      if (btn.closest('.small-cart') === null) {
        if (btn.innerHTML !== reloadHTML) {
          oldBtnsHTML[index] = btn.innerHTML;
        }

        if (state) {
          btn.classList.add('btn-order-reload');
          btn.innerHTML = reloadHTML;
        } else {
          btn.classList.remove('btn-order-reload');
          btn.innerHTML = oldBtnsHTML[index];
        }
      }
    });
  }
}
